// extracted by mini-css-extract-plugin
export default {"vmv_research_container":"VMVResearch_vmv_research_container__fr55d"};